// src/PatientProfileProvider.tsx
import React, { createContext, useContext, useState, ReactNode } from "react";

type Goal = {
  description: string;
  progress: string;
};

type FormattedGoal = {
  title: string;
  cardTitle: any;
  cardSubtitle: string;
  items: any;
};

type PatientData = {
  patient_name: string;
  patient_id: string;
  goals: Goal[];
  summary: string;
  number_of_sessions: number;
  formattedGoals: FormattedGoal[];
};

type PatientProfileContextType = {
  patientData: PatientData | null;
  setPatientData: (data: PatientData | null) => void;
  isInfoBarOpen: boolean;
  setIsInfoBarOpen: (open: boolean) => void;
};

const PatientProfileContext = createContext<PatientProfileContextType | undefined>(undefined);

export const usePatientProfile = () => {
  const context = useContext(PatientProfileContext);
  if (!context) {
    throw new Error("usePatientProfile must be used within a PatientProfileProvider");
  }
  return context;
};

export const PatientProfileProvider = ({ children }: { children: ReactNode }) => {
  const [patientData, setPatientData] = useState<PatientData | null>(null);
  const [isInfoBarOpen, setIsInfoBarOpen] = useState(false);

  return (
    <PatientProfileContext.Provider value={{ patientData, setPatientData, isInfoBarOpen, setIsInfoBarOpen }}>
      {children}
    </PatientProfileContext.Provider>
  );
};
